import React from 'react';
import { Container } from '@pixi/react';
import GameRulesFooter from './gameRulesFooter';
import { isMobile } from '../../../../core/helpers/isMobile';

function GameRulesWrapper({ GameRulesContent, x }) {
  return (
    <Container name='GameRulesWrapper' x={x}>
      <GameRulesContent />
      <GameRulesFooter x={isMobile() ? 261 : 594} y={isMobile() ? 866 : 750} />
    </Container>
  );
}

export default GameRulesWrapper;
